export default __webpack_public_path__ + "static/tamburini-8c6c5146385629d1a569f27d9bec14bf.jpeg";